import { j as i } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as l } from "../../../../IconBase-CxZyIWw2.js";
const a = r((c, s) => /* @__PURE__ */ i.jsx(
  l,
  {
    ref: s,
    ...c,
    image: (h) => /* @__PURE__ */ i.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...h,
        children: [
          /* @__PURE__ */ i.jsxs("g", { fill: "#1D1D44", clipPath: "url(#clip0_744_622)", children: [
            /* @__PURE__ */ i.jsx("path", { d: "M14.91 9.53c.13-.22.47-.06.37.18-4.14 10.5-5.66 19.98-5.05 24.63.37 2.78-3.04 2.78-3.04 0 0-4.59.6-15.33 7.72-24.81M27.78 5.67c-.26-.14-.57-.05-.74.2-6.36 9.65-7.31 17.22-8.5 26.8-.15 1.18-.3 2.4-.47 3.64-.28 2.11.4 3.84 1.86 4.73.62.38 1.33.57 2.03.57.76 0 1.51-.22 2.14-.65 1.33-.92 1.88-2.61 1.5-4.63-2.5-13.28-.92-21.3 2.44-29.94.11-.28 0-.58-.27-.72zM41.78 5.08a.56.56 0 0 0-.72.14c-5.92 7.34-6.96 17.15-7.8 25.03-.2 1.88-.39 3.65-.63 5.29-.27 1.86.28 3.39 1.53 4.2.55.35 1.18.53 1.81.53s1.25-.17 1.79-.52c1.25-.8 1.82-2.31 1.56-4.16-1.43-10.32-1.44-18.51 2.7-29.8.1-.27 0-.56-.25-.7z" }),
            /* @__PURE__ */ i.jsx("path", { d: "M41.16 31.12H45v-1.5h-3.84c-1.05-.03-1.86 1.08-1.53 2.07.56 1.82 1.69 6.3-.01 8.62-1.24 2-6.09 2-7.32 0-1.7-2.31-.58-6.79-.01-8.62.34-.99-.48-2.1-1.53-2.07h-2.97c-.6-.04-1.17.2-1.53.69-.32.44-.41.99-.25 1.5.63 2.03 1.88 7.02-.02 9.61-1.4 2.25-6.84 2.25-8.23 0-1.91-2.6-.65-7.58-.02-9.6.36-1.06-.51-2.23-1.63-2.2h-3.8c-.87-.02-1.57.91-1.29 1.74.8 2.57.81 4.74.03 5.8-.78 1.27-3.96 1.27-4.74 0-.78-1.06-.77-3.23.03-5.79.29-.83-.41-1.77-1.29-1.75.01-.01-2.05-.01-2.05-.01v1.5h1.85c-.55 1.84-1.17 5 .26 6.93 1.34 2.08 5.82 2.08 7.16 0 1.37-1.86.85-4.85.32-6.72-.03-.11.05-.21.17-.21h3.36c.08 0 .14.05.17.09-.67 2.87-2.08 7.96.27 11.1 1.96 3.06 8.68 3.07 10.65 0 2.23-3.03 1.11-8.15.25-10.94-.03-.15.03-.23.18-.25h3.13l.09.13c-1.51 4.45-2.07 12.15 5.11 12.05 7.18.1 6.61-7.6 5.11-12.05 0 0-.06-.13.09-.13z" })
          ] }),
          /* @__PURE__ */ i.jsx("defs", { children: /* @__PURE__ */ i.jsx("clipPath", { id: "clip0_744_622", children: /* @__PURE__ */ i.jsx("path", { fill: "#fff", d: "M3 5h42v39.6H3z" }) }) })
        ]
      }
    )
  }
));
a.displayName = "HairThickerIcon";
export {
  a as HairThickerIcon,
  a as default
};
//# sourceMappingURL=index.js.map
